var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnValue3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.267,
    height: 86.936,
    viewBox: "0 0 86.267 86.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-value3",
    transform: "translate(-1056.866 -4152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2427",
    "data-name": "Groupe 2427",
    transform: "translate(1056.866 4152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 86.267,
    height: 86.936,
    rx: 20,
    fill: "rgba(255,186,70,0.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2426",
    "data-name": "Groupe 2426",
    transform: "translate(1025.014 4120.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2326",
    "data-name": "Trac\\xE9 2326",
    d: "M239.639,45a2.225,2.225,0,0,1,1.3,2.357c-.055,2.162,0,4.327-.023,6.49a1.739,1.739,0,0,1-2.376,1.684,1.633,1.633,0,0,1-1.118-1.567c-.023-2.417-.016-4.834-.006-7.251A1.942,1.942,0,0,1,238.7,45Z",
    transform: "translate(-164.182 0)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2327",
    "data-name": "Trac\\xE9 2327",
    d: "M45,238.61a2.225,2.225,0,0,1,2.357-1.3c2.162.055,4.327,0,6.49.023a1.739,1.739,0,0,1,1.684,2.376,1.633,1.633,0,0,1-1.567,1.118c-2.417.023-4.834.016-7.251.006A1.942,1.942,0,0,1,45,239.547Z",
    transform: "translate(0 -164.091)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2328",
    "data-name": "Trac\\xE9 2328",
    d: "M157.25,176.878q-3.338,0-6.676,0a1.8,1.8,0,0,1-2.061-2.032,9.159,9.159,0,0,0-2.651-6.539,15.8,15.8,0,1,1,23.184-.319,9.732,9.732,0,0,0-2.761,4.92,13.825,13.825,0,0,0-.194,1.916c-.043,1.419-.669,2.052-2.106,2.053Q160.617,176.881,157.25,176.878ZM157,148.654a8.661,8.661,0,0,0-8.081,6.106,1.779,1.779,0,0,0,1.034,2.432,1.745,1.745,0,0,0,2.269-1.273,5.124,5.124,0,0,1,4.958-3.751,1.769,1.769,0,1,0-.181-3.514Z",
    transform: "translate(-82.31 -82.445)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2329",
    "data-name": "Trac\\xE9 2329",
    d: "M201.526,406.045h13.962c.359,2.89-.4,5.213-2.952,6.464a5.229,5.229,0,0,1-1.961.5,31.81,31.81,0,0,1-4.094,0,5.165,5.165,0,0,1-4.947-4.931C201.476,407.427,201.526,406.762,201.526,406.045Z",
    transform: "translate(-133.545 -308.075)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2330",
    "data-name": "Trac\\xE9 2330",
    d: "M386.45,240.92c-1.113,0-2.225.006-3.338,0a1.763,1.763,0,1,1-.018-3.51q3.4-.011,6.793,0a1.763,1.763,0,1,1,.018,3.51C388.753,240.927,387.6,240.92,386.45,240.92Z",
    transform: "translate(-286.853 -164.175)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2331",
    "data-name": "Trac\\xE9 2331",
    d: "M103.951,101.924a3.984,3.984,0,0,1,1.032.588c1.641,1.587,3.249,3.209,4.85,4.837a1.752,1.752,0,1,1-2.47,2.479c-1.628-1.6-3.238-3.22-4.848-4.84a1.723,1.723,0,0,1-.433-1.985A1.871,1.871,0,0,1,103.951,101.924Z",
    transform: "translate(-48.582 -48.573)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2332",
    "data-name": "Trac\\xE9 2332",
    d: "M347.531,103.894a4.372,4.372,0,0,1-.616,1.064c-1.588,1.64-3.209,3.249-4.838,4.849a1.749,1.749,0,1,1-2.5-2.447q2.438-2.488,4.924-4.928a1.664,1.664,0,0,1,1.994-.352A1.876,1.876,0,0,1,347.531,103.894Z",
    transform: "translate(-250.888 -48.547)",
    fill: "#ffaa1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnValue3);
export default __webpack_public_path__ + "static/media/icn-value3.70d734960246b05a17b6bdd604fb6294.svg";
export { ForwardRef as ReactComponent };